<template>
  <div class="container">
    <payoff >
			<h1
				v-html="`La Spesa a Casa Tua`"
			/>
			<div class='flex-center'>
				<CTA
					@click="scrollToDivId('more')"
					isArrowDown
					:content="`Approfittane ora!`"
				/>
			</div>
			<br> 
			<div class="subtitle">
				<i class="fa fa-check" aria-hidden="true"></i>
				A partire da soli
				<span>&nbsp;</span>
			</div>

			<div class="subtitle orange">
				Ancora più conveniente, solo questa settimana!
			</div>
		</payoff>

    		<section class="content-panel">
			<h2
				class="center"
				v-html="`È facile`"
			/>
				
			<br>
			<div class="flex wrap">
				<div class="col-sm-4 col-xs-12">
					<img src="../../assets/img/badges/home/calendar.png" class="usp-icon" alt="Pianifica le tue cene">
					<h3>Pianifica le tue cene</h3>
					<p>Scegli il numero di porzioni e<br> di ricette dal menù settimanale</p>
				</div>
				<div class="col-sm-4 col-xs-12">
					<img src="../../assets/img/badges/home/box.png" class="usp-icon" alt="Ricevi gli ingredienti">
					<h3>Ricevi gli ingredienti</h3>
					<p>Ogni settimana una box<br> con ingredienti freschi e stagionali</p>
				</div>
				<div class="col-sm-4 col-xs-12">
					<img src="../../assets/img/badges/home/fork.png" class="usp-icon" alt="Prepara piatti deliziosi">
					<h3>Prepara piatti deliziosi</h3>
					<p>Divertiti in cucina<br> con le nostre semplici istruzioni</p>
				</div>
			</div>
			<div id="more" />
			<br>
			<hr>
		</section>

		<section>
			<br>
			<h2 class="center">
				Prova la tua prima Food Box senza impegno!
			</h2>
			<center>
				<p>Potrai sospendere l'abbonamento dopo il primo ordine</p>
				<div class="alert-people">
					<b>
						<i class="fas fa-exclamation-triangle" /> Altre {{ peopleCounter }} persone stanno guardando l'offerta
					</b>
				</div>
			</center>
		</section>
    
    <div class="checkout-container flex flex-wrap">
      <div class="checkout-panel">
				<section>
          <div class="shadow-box">
						<div
							class="section-title"
							id="step1"
						>
							<h2>Seleziona le box che preferisci</h2>
							<div class="flex-right">
								<i aria-hidden="true" class="fas fa-pencil-alt" />
							</div>
						</div>
          </div>    
				</section>

        <div class="section-content">
						<div class="recipes-listing">
							<extra-box                                       
									class="recipe-box"
									v-for="(product, index) in extras"
									:key="index"
									:item="product"
							>
							</extra-box>
						</div>

						<div id="afterRecipesConfirm" />

						<br>


					</div>
			</div>
    </div>

  </div>
</template>

<script type = "text/javascript">
import Payoff from '../Parts/Payoff.vue'
import { scrollToElementId } from '../../assets/js/main'
import { ExtraApi } from '../../api/ExtraApi'
import ExtraBox from '../Ecommerce/ExtraBox.vue'


export default {
  components: { 
    Payoff,
		ExtraBox
    },

    data() {
      return {
        peopleCounter: 11,
        step: {
          1: {
            completed: false,
            editedMode: true
          },
          2: {
            completed: false,
            editedMode: false
          },
          3: {
            completed: false,
            editedMode: false
          },
          4: {
            completed: false,
            editedMode: false
          },
          5: {
            completed: false,
            editedMode: false
          },
          6: {
            completed: false,
            editedMode: false
          }
        },
				extras: [],
				sections: []
      }
    },

    methods: {
      scrollToDivId (target) {
        scrollToElementId(target)
      },

      setPeopleCounter () {
        var min = 11
        var max = 47
        var setter = (Math.random() * (+max - +min) + +min)
        this.peopleCounter = Math.round(setter)
      },
			
			loadExtras () {
				var em = new ExtraApi()
				return em.all({
					params: {
						show: 10,
						page: 1,
						sort_direction: 'asc',
						query: `shopTags.name in ('Cassette')`
					}
				})

				.then(response => {
					this.extras = response.body.data.resources
					this.extras.sort((a,b) => {
						return a.price - b.price
					})
				})

				.catch(response => {
				})
			},

			 getShopTags () {
            if (!this.section) {
                return []
            }
            
            return this.section.tags || []
        },
    },

    mounted () {
		this.setPeopleCounter()
		},

		created() {
			this.loadExtras()
		}
}
</script>

<style scoped> 
.disabled-label {
	color: red;
	font-size: 15px;
}

h1 {
	font-size: 30px;
}

h2, h3 {
	text-align: center;
}
.plan {
	padding: 20px;
	text-align: center;
	margin: 20px 10px;
	cursor: pointer;
	flex-grow: 1;
	max-width: 250px;
}

.plan .plan-title {
	font-size: 26px;
	font-weight: 500;
}

.plan .plan-people {
	font-size: 20px;
}
* >>> .btn,
* >>> .btn:hover {
	margin: 0 auto;
}

* >>> .delivery-list {
	margin: 0 auto;
}

.orange {
	color: orange;
	font-weight: bold;
}

.float {
    position: -webkit-sticky;
    position: sticky;
    top: 100px;
}

.usp-icon {
	max-width: 50px;
	margin-bottom: 20px;
}

.alert-people {
	border-radius: 4px;
    max-width: 392px;
    background: var(--quomi-orange-hover);
    color: white;
    margin: 0 10px;
}

.alert-people .fas {
	font-size: 12px;
	vertical-align: 1px;
}

.payment-icons {
	display: flex;
	justify-content: center;
	align-items: center;
}
.payment-icons img {
	height: 40px;
}

.payment-icons .paypal-icon {
	height: 30px;
}
.flex-right {
	text-align: right;
}

.fa-pencil-alt {
	cursor: pointer;
}

.fa-check {
	color: var(--quomi-primary);
}

.subtitle {
	padding-top: 10px;
	position: relative;
	font-size: 18px;
}

.checkout-container {
    position: relative;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px 30px 20px;
}

.checkout-container section {
	padding: 10px;
}

.content-panel {
	max-width: 1000px;
	margin: 30px auto;
	text-align: center;
}

.checkout-panel {
    flex-basis: calc(100% - 400px);
    border-radius: 6px;
    background-color: white;
    align-self: flex-start; 
    text-align: center;
}

.section-title:before {
	content: attr(data-step-number);
	border: 3px solid var(--quomi-darkgrey);
	flex-basis: 25px;
	min-width: 25px;
	height: 25px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-left: -41px;
	margin-right: 15px;
	color: var(--quomi-darkgrey);
	font-weight: 700;
}

.section-title {
	width: 100%;
	display: flex;
	justify-content: flex-start;
	padding: 10px 30px 10px 55px;
	align-items: center;
	background-color: white;
	border-radius: 4px;
}

.section-title h2 {
	margin-bottom: 0;
	text-align: left;
}

.section-content {
	margin: 20px 5px;
}

.section-content >>> #section-shipment {
	text-align: left;
	max-width: 500px;
	margin: 0 auto;
	border-top: 1px solid #ededed;
	border-bottom: 1px solid #ededed;
    padding: 25px 0;
}

.section-content >>> #section-shipment hr:first-child {
	display: none;
}

.section-content >>> .delivery-option {
	margin-right: auto;
	margin-left: auto;
	text-align: left;
}

[data-step-number="0"] {
	border: 3px solid var(--quomi-primary);
}

[data-step-number="0"]:before {
	color: #fff;
	border-color: var(--quomi-primary);
	content: '\f00c';
	font-family: 'FontAwesome';
	background-color: var(--quomi-primary);
}

.sidebar-panel {
    padding-left: 25px;
    width: 400px;
    padding-bottom: 40px;
    position: relative;
}

.sidebar-panel_inner {
    border-radius: 6px;
    background-color: #fbf1d7;
    padding: 25px;
    min-height: 150px;
}

.icons {
	padding: 10px 0;
}

.section-recipes {
	max-width: 1000px;
	margin: 0 auto;
}

.recipes-listing {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	margin: 0 -10px;
	align-items: flex-start;
}

.recipe-box {
	text-align: left;
	flex-basis: calc(100% / 3 - 10px);
	max-width: calc(100% / 3 - 10px);
	margin: 5px;
}

.recipe-box.disabled {
	opacity: 0.5;
}


#checkout-bill	h3 {
	font-weight: bold;
	margin-bottom: 30px;
	text-align: left;
}

#checkout-bill	h4 {
	font-size: 14px;
	margin-bottom: 5px;
	font-weight: 500;
}

.small-text {
	font-size: 13px;
	padding-top: 6px;
}


@media (max-width: 1024px) {
	.recipe-box {
		flex-basis: calc(100% / 2 - 10px);
		max-width: calc(100% / 2 - 10px);
	}

	* >>> #payoff {
		background-position: center 100%;
	}

	.subtitle {
		font-size: 16px;
	}

	.checkout-panel{
        flex-basis: 100%;
    }

    .sidebar-panel {
        flex-basis: 100%;
        padding-top: 30px;
        padding-left: 0;
        margin: 0 20px 20px 20px;
    }
}

@media (max-width: 600px) {
	.recipe-box {
		flex-basis: calc(100% / 1 - 10px);
		max-width: calc(100% / 1 - 10px);
	}
}


</style>
